<template>
    <div class="load-body">
        <div class="load-top">
            <div class="top-left">
                <img src="../assets/imgs/icon.png" alt="">
                <div class="icon-info">
                    <p>米悅小說APP</p>
                </div>
            </div>
            <div class="close-btn">
                <img src="../assets/imgs/close.png" @click="backAgo">
            </div>
        </div>
        <div class="copy-area">
            <div class="copy-font">免費禮包碼：MY</div>
            <div class="copy-btn" @click="copy">複制</div>
        </div>
        <div class="show-area">
            <img src="../assets/imgs/show.png" alt="">
        </div>
        <a :href="downLoadUrl" target="_blank"><div class="load-btn">立即下載</div></a>
        <div class="use-des">
            <div class="use-info">
                <div class="use-title">禮包使用方法:</div>
                <p>1、下載APP并登錄</p>
                <p>2、個人中心“我的帳戶”，福利碼兌換粘帖禮包碼</p>
                <p>3、粘貼禮包碼獲取禮包</p>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
  name: "loadpage",
  data() {
    return {
      downLoadUrl:
        "https://play.google.com/store/apps/details?id=my.goodnovel.app"
    };
  },
  mounted: function() {
    var platForm = this.go.getMobileBrowser();
    if (platForm == "IOS") {
      this.downLoadUrl = "https://itunes.apple.com/app/id1436800234";
    }
  },
  methods: {
    backAgo() {
      this.$router.back(-1);
    },
    copy: function() {
      //todo
      window.clipboardData?window.clipboardData.setData("Text","MY"):"";
    }
  }
};
</script>

<style scoped>
.load-body {
  width: 100%;
  height: 13.4em;
  background: #fffaf5;
  overflow: hidden;
}
.load-top {
  width: 100%;
  padding: 0.6rem 0.4rem 0.88rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.top-left {
  display: flex;
}
.top-left img {
  display: block;
  width: 0.78rem;
  height: 0.78rem;
}
.load-btn a {
  color: #fff;
  text-decoration: none;
}
.icon-info {
  height: 0.78rem;
  color: #ff1f4f;
  padding-left: 0.22rem;
}
.icon-info p:first-child {
  font-size: 0.4rem;
  font-weight: 700;
  line-height: 0.4rem;
  padding-bottom: 0.16rem;
}
.icon-info p:last-child {
  font-size: 0.4rem;
  line-height: 0.78rem;
}
.close-btn {
  width: 0.36rem;
  height: 0.36rem;
}
.close-btn img {
  display: block;
  width: 0.36rem;
  height: 0.36rem;
}
.copy-area {
  width: 100%;
  height: auto;
  padding: 0 0.6rem 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}
.copy-font {
  font-size: 0.34rem;
  line-height: 0.34rem;
  color: #ff1f4f;
  font-weight: 700;
}
.copy-btn {
  width: 1.82rem;
  height: 0.7rem;
  background: #ff1f4f;
  border-radius: 0.08rem;
  font-size: 0.42rem;
  line-height: 0.7rem;
  text-align: center;
  color: #ffffff;
}
.show-area {
  width: 5.4rem;
  padding-bottom: 0.38rem;
  margin: 0 auto;
}
.show-area img {
  display: block;
  width: 5.4rem;
  height: 4.64rem;
}
.use-des {
  width: 100%;
  height: auto;
  padding: 0 1.05rem 0.2rem;
  box-sizing: border-box;
}
.use-info {
  width: 100%;
  height: 3rem;
  border: 0.02rem dashed #ff1f4f;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  padding: 0.35rem 0 0 0.55rem;
}
.use-title {
  font-size: 0.34rem;
  line-height: 0.34rem;
  padding: 0 0.34rem;
  background: #fffaf5;
  position: absolute;
  left: 0.54rem;
  top: -0.2rem;
  color: #ff1f4f;
  font-weight: 700;
}
.use-info p {
  font-size: 0.34rem;
  line-height: 0.5rem;
  padding-bottom: 0.1rem;
  color: #ff1f4f;
  font-weight: 700;
}
.load-btn {
  width: 5.4rem;
  height: 0.86rem;
  background: #ff1f4f;
  font-size: 0.34rem;
  line-height: 0.86rem;
  text-align: center;
  border-radius: 0.08rem;
  margin: 0 auto;
  color: #ffffff;
  font-weight: 700;
  margin-bottom: 0.6rem;
}
</style>


// WEBPACK FOOTER //
// src/components/loadpage.vue